import React, { Component } from 'react';
import { Link } from 'react-router-dom';

let jsonp = require('jsonp'),
    $window = window,
    letters = document.getElementsByClassName('letter');

class Dogs extends Component {

  constructor(props) {
    super(props);

    this.img = [];
    this.style = {};

    this.letters = ['A','B','C','D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
    'N', 'O', 'P', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

    this.dogBreeds = [
      {
       "name": "affenpinscher", 
       "img" : "n02110627_5186.jpg",
       "size": "small"
      },
      {
       "name": "airedale", 
       "img" : "n02096051_3472.jpg",
       "bgPosition" : "top",
       "size": "medium"
      },
      {
        "name": "akita", 
        "img" : "Japaneseakita.jpg",
        "bgPosition" : "right",
        "size": "large"
       },
       {
        "name": "australian silky terrier", 
        "image" : "https://upload.wikimedia.org/wikipedia/commons/thumb/4/48/02_Australian_Silky_Terrier%2C_Zack%2C_spring_2012.jpg/1280px-02_Australian_Silky_Terrier%2C_Zack%2C_spring_2012.jpg",
        "bgPosition": "center",
        "size": "small"
      },
      {
        "name": "australian cattle dog", 
        "img" : "IMG_9350.JPG",
        "size": "medium"
      },
       {
        "name": "alaskan malamute", 
        "img": "n02110063_16713.jpg",
        "bgPosition": "center",
        "size": "large"
      },
       {
        "name": "american eskimo dog", 
        "image" : "https://upload.wikimedia.org/wikipedia/commons/4/47/American_Eskimo_Dog.jpg",
        "size": "medium"
       },
       {
        "name": "basenji",
        "image": "https://upload.wikimedia.org/wikipedia/commons/2/24/Asia_figlia_di_Dulcinea_%26_Daiquiri.jpg",
        "bgPosition": "center",
        "size": "large"
       },
       {
        "name": "beagle",
        "img" : "n02088364_4473.jpg",
        "bgPosition": "center",
        "size": "medium"
       },
       {
         "name": "bluetick coonhound", 
         "image" : "https://farm1.staticflickr.com/108/255195899_1734ba77e9_z.jpg",
         "size": "large",
         "bgPosition": "center"
        },
        {
          "name": "borzoi", 
          "img" : "n02090622_6131.jpg",
          "bgPosition": "top",
          "size": "large"

         },
         {
          "name": "boxer", 
          "img" : "n02108089_1357.jpg",
          "bgPosition": "top",
          "size": "large"

         },
         {
          "name": "briard", 
          "img" : "n02105251_6301.jpg",
          "bgPosition": "right",
          "size": "large"

         },
         {
           "name": "boston terrier", 
           "image" : "https://upload.wikimedia.org/wikipedia/commons/f/f3/Boston_Terrier_male.jpg",
           "bgPosition": "center",
           "size": "small"
          },
          {
           "name": "brittany", 
           "img" : "n02101388_3195.jpg",
           "bgPosition": "top",
           "size": "medium"
          },
          {
           "name": "french bulldog", 
           "img" : "n02108915_5201.jpg",
           "bgPosition": "center",
           "size": "small"
          },
          {
            "name": "cairn terrier", 
            "img" : "n02096177_12103.jpg",
            "bgPosition": "center",
            "size": "small"
          },
          {
            "name": "chihuahua", 
            "img" : "n02085620_2479.jpg",
            "bgPosition": "center",
            "size": "small"
          },
          {
            "name": "chow chow", 
            "img" : "n02112137_7616.jpg",
            "bgPosition": "center",
            "size": "medium"
          },
          {
            "name": "clumber spaniel", 
            "img" : "n02101556_2677.jpg",
            "bgPosition": "center",            
            "size": "medium"
          },
          {
            "name": "border collie", 
            "img" : "n02106166_1059.jpg",
            "bgPosition": "center",
            "size": "medium"
          },
          {
            "name": "cardigan welsh corgi", 
            "img" : "n02113186_7308.jpg",
            "bgPosition": "center",
            "size": "small"
          },
          {
            "name": "staffordshire bull terrier", 
            "img" : "n02093256_11836.jpg",
            "bgPosition": "center",
          },
          {
            "name": "dachshund", 
            "img" : "dachshund-7.jpg",
            "size": "small"
          },
          {
            "name": "dalmatian", 
            "image" : "https://upload.wikimedia.org/wikipedia/commons/d/da/Dalmatian_puppy.JPG",
            "bgPosition": "center",
            "size": "large"
          },
          {
            "name": "great dane", 
            "img" : "n02109047_22193.jpg",
            "bgPosition": "center",
            "size": "large"
          },
          {
            "name": "scottish deerhound", 
            "img" : "n02092002_6963.jpg",
            "bgPosition": "center",
            "size": "large"
          },
          {
            "name": "dobermann", 
            "img" : "n02107142_8399.jpg",
            "bgPosition": "center",
            "size": "large"
          },
          {
            "name": "norwegian elkhound", 
            "img" : "n02091467_5654.jpg",
            "bgPosition": "center",
            "size": "large"
          },
          {
            "name": "labrador retriever", 
            "img" : "n02099712_610.jpg",
            "bgPosition": "center",
            "size": "large"
          },
          {
            "name": "german shepherd", 
            "img" : "n02106662_808.jpg",
            "bgPosition": "center",
            "size": "large"
          },
          {
            "name": "italian greyhound", 
            "img" : "n02091032_1072.jpg",
            "size": "medium"
          },
          {
            "name": "afghan hound", 
            "image" : "https://upload.wikimedia.org/wikipedia/commons/f/fe/Afghan_Hound.jpg",
            "size": "large"
          },
          {
            "name": "basset hound", 
            "img" : "n02088238_1454.jpg",
            "size": "medium"
          },
          {
            "name": "bloodhound", 
            "img" : "n02088466_10724.jpg",
            "size": "large"
          },
          {
            "name": "ibizan hound",
            "img" : "n02091244_4395.jpg",
            "bgPosition": "center",           
            "size": "large"
          },
          {
            "name": "siberian husky",
            "image" : "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/Siberian_Husky_blue_eyes_Flickr.jpg/1150px-Siberian_Husky_blue_eyes_Flickr.jpg",
            "bgPosition": "center",                      
            "size": "large"
          },
          {
            "name": "keeshond",
            "img" : "n02112350_7733.jpg",
            "bgPosition": "center",
            "size": "large"
          },
          {
            "name": "komondor",
            "img" : "n02105505_2570.jpg",
            "bgPosition": "center",
            "size": "large"
          },
          {
            "name": "leonberger",
            "img" : "n02111129_990.jpg",
            "bgPosition": "center",
            "size": "small"
          },
          {
            "name": "lhasa apso",
            "img" : "n02098413_14953.jpg",
            "bgPosition": "center",
            "size": "small"

          },
          {
            "name": "jack russell terrier",
            "image": "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/Jack_Russell_Terrier_2.jpg/1599px-Jack_Russell_Terrier_2.jpg",
            "bgPosition": "center",           
            "size": "small"
          },
          {
            "name": "maltese",
            "img" : "n02085936_6348.jpg",
            "bgPosition": "center",
            "size": "small"
          },
          {
            "name": "bullmastiff",
            "img" : "n02108422_1869.jpg",
            "size": "large"
          },
          {
            "name": "tibetan mastiff",
            "img" : "n02108551_3840.jpg",
            "size": "large"
          },
          {
            "name": "mexican hairless dog",
            "img" : "n02113978_1620.jpg",
            "bgPosition": "right",
            "size": "large"
          },
          {
            "name": "bernese mountain dog",
            "img" : "n02107683_2059.jpg",
            "bgPosition": "center",
            "size": "large"
          },
          {
            "name": "newfoundland",
            "img" : "n02111277_1018.jpg",
            "size": "large"
          },
          {
            "name": "otterhound",
            "img" : "n02091635_1590.jpg",
            "size": "large"
          },
          {
            "name": "papillon",
            "img" : "n02086910_5031.jpg",
            "bgPosition": "center",
            "size": "small"
          },
          {
            "name": "pekingese",
            "img" : "n02086079_11089.jpg",
            "bgPosition": "center",
            "size": "small"
          },
          {
            "name": "miniature pinscher",
            "img" : "n02107312_5114.jpg",
            "size": "small"
          },
          {
            "name": "pointer",
            "image" : "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/English_Pointer_001.jpg/1599px-English_Pointer_001.jpg",
            "bgPosition": "center",            
            "size": "large"
          },
          {
            "name": "pomeranian",
            "img" : "n02112018_3097.jpg",
            "size": "small"
          },
          {
            "name": "poodle",
            "img" : "n02113624_3960.jpg",
            "size": "any"
          },
          {
            "name": "pug",
            "img" : "n02110958_13993.jpg",
            "bgPosition": "center",
            "size": "small"
          },
          {
            "name": "great pyrenees",
            "img" : "n02111500_124.jpg",
            "bgPosition": "center",
            "size": "large"
          },
          {
            "name": "chesapeake bay retriever",
            "img" : "n02099849_2375.jpg",
            "bgPosition": "center",
            "size": "large"
          },
          {
            "name": "curly-coated retriever",
            "img" : "n02099429_273.jpg",
            "bgPosition": "center",
            "size": "large"
          },
          {
            "name": "flat-coated retriever",
            "img" : "n02099267_1533.jpg",
            "size": "large"
          },
          {
            "name": "golden retriever",
            "img" : "n02099601_1010.jpg",
            "size": "large"
          },
          {
            "name": "rhodesian ridgeback",
            "img" : "n02087394_4741.jpg",
            "bgPosition": "center",
            "size": "large"
          },
          {
            "name": "rottweiler",
            "img" : "n02106550_13034.jpg",
            "size": "large"
          },
          {
            "name": "saluki",
            "img" : "n02091831_1565.jpg",
            "bgPosition": "center",
            "size": "large"
          },
          {
            "name": "samoyed",
            "img" : "n02111889_6249.jpg",
            "bgPosition": "center",
            "size": "medium"
          },
          {
            "name": "schipperke",
            "img" : "n02104365_9041.jpg",
            "bgPosition": "center",
            "size": "small"
          },
          {
            "name": "giant schnauzer",
            "img" : "n02097130_5175.jpg",
            "bgPosition": "center",
            "size": "large"
          },
          {
            "name": "miniature schnauzer",
            "img" : "n02097047_328.jpg",
            "bgPosition": "center",
            "size": "small"
          },
          {
            "name": "english setter",
            "img" : "n02100735_3942.jpg",
            "bgPosition": "center",
            "size": "medium"
          },
          {
            "name": "irish setter",
            "img" : "n02100877_5184.jpg",
            "size": "medium"
          },
          {
            "name": "old english sheepdog",
            "img" : "n02105641_3585.jpg",
            "bgPosition": "center",
            "size": "large"
          },
          {
            "name": "shetland sheepdog",
            "img" : "n02105855_15506.jpg",
            "bgPosition": "center",
            "size": "large"
          },
          {
            "name": "shiba inu",
            "img" : "shiba-14.jpg",
            "size": "large"
          },
          {
            "name": "shih tzu",
            "img" : "n02086240_12315.jpg",
            "bgPosition": "center",
            "size": "small"
          },
          {
            "name": "king charles spaniel",
            "image" : "https://upload.wikimedia.org/wikipedia/commons/a/ac/Cavalier-king-charles-spaniels.jpg",
            "bgPosition": "center",
            "size": "medium"
          },
          {
            "name": "cocker spaniel",
            "img" : "n02102318_9680.jpg",
            "bgPosition": "center",
            "size": "medium"
          },
          {
            "name": "irish water spaniel",
            "img" : "n02102973_1622.jpg",
            "size": "medium"
          },
          {
            "name": "japanese chin",
            "image" : "https://upload.wikimedia.org/wikipedia/commons/d/d7/Japanese_Chin_-_with_tongue_and_teeth.JPG",
            "bgPosition": "center",      
            "size": "small"
          },
          {
            "name": "sussex spaniel",
            "img" : "n02102480_41.jpg",
            "size": "medium"
          },
          {
            "name": "welsh springer spaniel",
            "image": "https://upload.wikimedia.org/wikipedia/commons/5/5e/Welsh_Springer_Spaniel_Dog.jpg",
            "bgPosition": "center",      
            "size": "medium"
          },
          {
            "name": "english springer spaniel",
            "img" : "n02102040_735.jpg",
            "bgPosition": "center",
            "size": "medium"
          },
          {
            "name": "american pit bull terrier",
            "image" : "https://images.pexels.com/photos/825944/pexels-photo-825944.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
            "bgPosition": "center",
            "size": "large"
          },
          {
            "name": "bedlington terrier",
            "img" : "n02093647_655.jpg",
            "size": "medium"
          },
          {
            "name": "border terrier",
            "img" : "n02093754_180.jpg",
            "bgPosition": "center",
            "size": "small"
          },
          {
            "name": "dandie dinmont terrier",
            "img" : "n02096437_1614.jpg",
            "size": "small"
          },
          {
            "name": "fox terrier",
            "img" : "n02095314_669.jpg",
            "bgPosition": "center",
            "size": "small"
          },
          {
            "name": "irish terrier",
            "img" : "n02093991_4501.jpg",
            "bgPosition": "center",
            "size": "small"
          },
          {
            "name": "kerry blue terrier",
            "img" : "n02093859_1213.jpg",
            "bgPosition": "center",
            "size": "small"
          },
          {
            "name": "lakeland terrier",
            "img" : "n02095570_2639.jpg",
            "bgPosition": "center",
            "size": "small"
          },
          {
            "name": "norwich terrier",
            "img" : "n02094258_2732.jpg",
            "bgPosition": "center",
            "size": "small"
          },
          {
            "name": "scottish terrier",
            "img" : "n02097298_132.jpg",
            "bgPosition": "bottom",
            "size": "medium"
          },
          {
            "name": "tibetan terrier",
            "img" : "n02097474_3661.jpg",
            "bgPosition": "right",
            "size": "small"
          },
          {
            "name": "west highland white terrier",
            "img" : "n02098286_1814.jpg",
            "bgPosition": "center",
            "size": "medium"
          },
          {
            "name": "yorkshire terrier",
            "img" : "n02094433_3010.jpg",
            "bgPosition": "center",
            "size": "small"

          },
          {
            "name": "vizsla",
            "image" : "https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/Vizsla_dog_in_grass.JPG/900px-Vizsla_dog_in_grass.JPG",
            "bgPosition": "center",           
            "size": "large"
          },
          {
            "name": "weimaraner",
            "image" : "https://upload.wikimedia.org/wikipedia/commons/thumb/5/59/Weimaraner_Freika-2.jpg/990px-Weimaraner_Freika-2.jpg",
            "bgPosition": "center",            
            "size": "large"
          },
          {
            "name": "whippet",
            "image" : "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/Maverick_the_Whippet.jpg/922px-Maverick_the_Whippet.jpg",
            "bgPosition": "center",
            "size": "medium"
          },
          {
            "name": "irish wolfhound",
            "image" : "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b0/Irish_Wolfhound.jpg/884px-Irish_Wolfhound.jpg",
            "bgPosition": "center",            
            "size": "large"
          },
          {
            "name": "harrier",
            "image" : "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Beagle_harrier.JPG/1600px-Beagle_harrier.JPG",
            "bgPosition": "center",            
            "size": "medium"
          },
          {
            "name": "havanese",
            "image" : "https://upload.wikimedia.org/wikipedia/commons/4/42/Bichon_Havanese_Yoyo.png",
            "bgPosition": "center",
            "size": "small"
          },
          {
            "name": "st bernard",
            "img" : "n02109525_13146.jpg",
            "bgPosition": "center",
            "size": "large"
          }
    ];
  
    this.breedGroups = ['Hound', 'Spaniel', 'Retriever', 'Terrier'];
    this.sizes = ['Small', 'Medium', 'Large'];

    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.filterDogs = this.filterDogs.bind(this);
    this.resetDogs = this.resetDogs.bind(this);

    this.state = {
      breeds: [],
      description: [],
      showText: true,
      search: '',
      filters: [],
    };

  }

  componentDidMount() {

    document.getElementsByClassName('nav-item')[1].classList.remove('active');
    document.getElementsByClassName('nav-item')[0].classList.remove('active');
    document.getElementsByClassName('nav-item')[2].classList.add('active');

    if(navigator.userAgent.match("Edge")) {
      document.getElementsByClassName('filters')[0].value = "Group";
      document.getElementsByClassName('filters')[1].value = "Size";
    }

    this.setState({showText: false});
    this.setState({breeds: this.dogBreeds.sort((a,b) => a.name.localeCompare(b.name))});
    setTimeout(() => this.showImg(), 500);

    $window.addEventListener('scroll',(e) => {

      this.lazyload();
    }); 

    $window.addEventListener('load', () => {
      
      setTimeout(() => this.showImg(), 500);
    });

    if($window.innerWidth <= 768) {
      document.getElementsByClassName('clearBtn')[0].textContent = "All";
    } else {
      document.getElementsByClassName('clearBtn')[0].textContent = "Show All";
    }

    this.dogBreeds.map((breed) => {

      if($window.location.href === `https://campetty2016.github.io/Puppedia/dogs/${breed.name.replace(/ /g, '_')}`) {
          this.loadModal(breed.name);

      }
    });

    $window.addEventListener('resize', () => {

      if($window.location.href.match("https://campetty2016.github.io/Puppedia/dogs/")) {
        if($window.innerWidth > 480) {
          document.getElementsByClassName('mobileSearch')[0].style.display = "none";
          document.getElementsByClassName('fa-search')[1].style.display = "none";
          document.getElementsByClassName('searchFilters')[0].style.display = "none";
          document.getElementsByClassName('filters')[0].style.display = "block";
          document.getElementsByClassName('filters')[1].style.display = "block";

        } else {
          document.getElementsByClassName('searchFilters')[0].style.display = "block";
        }
      }  
    });

  };

  showImg() {

    let lazyImages = document.getElementsByClassName('dogPic');

    for(let i=0; i < lazyImages.length; i++) {

      if(i <= 30) {
        lazyImages[i].style.backgroundImage = lazyImages[i].getAttribute('data-src');
        lazyImages[i].style.opacity = 1;
      }

      lazyImages[i].style.backgroundPosition = lazyImages[i].getAttribute('data-bg');
    }

  }

  lazyload() {

    let lazyImages = document.getElementsByClassName('dogPic');

      for(let i=0; i < lazyImages.length; i++) {

        if(this.elementInViewport(lazyImages[i])){

          lazyImages[i].style.backgroundImage = lazyImages[i].getAttribute('data-src');
          lazyImages[i].style.opacity = 1;
        } 
      }
  }

  elementInViewport(el) {
    let img = el.getBoundingClientRect();

    return (
        img.top >= 0 &&
        img.left >= 0 &&
        img.bottom <= ($window.innerHeight || document.documentElement.clientHeight)
    );
  }

  resetDogs() {

    this.setState({filters: []});

    this.setState({breeds: this.dogBreeds.sort((a,b) => a.name.localeCompare(b.name))});
    setTimeout(() => this.showImg(), 500);

    document.getElementsByClassName('clearBtn')[0].style.opacity = 0;
    document.getElementsByClassName('filters')[0].value = "Group";
    document.getElementsByClassName('filters')[1].value = "Size";

    if($window.innerWidth <= 480) {
      document.getElementsByClassName('clearBtn')[0].style.transition = "none";
      document.getElementsByClassName('clearBtn')[0].style.display = "none";
      document.getElementsByClassName('filters')[0].style.display = "none";
      document.getElementsByClassName('filters')[1].style.display = "none";
      document.getElementsByClassName('searchFilters')[0].style.display = "block";
      document.getElementsByClassName('fa-search')[1].style.display = "block";
      document.getElementsByClassName('filters')[0].style.display = "none";
      document.getElementsByClassName('filters')[1].style.display = "none";
    }

    if($window.innerWidth <= 568) {
      document.getElementsByClassName('clearBtn')[0].style.opacity = 0;
      document.getElementsByClassName('clearBtn')[0].style.display = "none";
    }

    document.getElementsByClassName('search')[0].value = "";
    document.getElementsByClassName('mobileSearch')[0].value = "";
    document.getElementsByClassName('mobileSearch')[0].style.display = "none";

    document.getElementsByClassName('breedOptions')[0].style.display = "flex";

    for(let i=0; i < letters.length; i++) {
      letters[i].style.fontWeight = "normal";
    }

    document.getElementsByClassName('search')[0].value = "";
  }

  loadModal(breed) {

    document.getElementsByClassName('modalContent')[0].scrollTop = 0;

    let url = '',
        breeds = [];

    if (breed.split(' ').length > 1 && !breed.match("-") && !breed.match("st bernard")) {
      for(let i=0; i < breed.split(' ').length; i++) {
        breeds.push((breed.split(' ')[i][0].toUpperCase().concat(breed.split(' ')[i].substr(1, breed.length))));

        url += `https://en.wikipedia.org/w/api.php?format=json&action=query&prop=extracts|pageimages&piprop=original&titles=${breeds.toString().replace(/,/g,'_')}`;
      }

    } else {
      switch(breed) {
        case "chihuahua":
        case "akita":
        case "boxer":
        case "pomeranian":
        case "harrier":
          url += `https://en.wikipedia.org/w/api.php?format=json&action=query&prop=extracts|pageimages&piprop=original&titles=${breed.replace(' ', '_').concat('_(dog)')}`;

        break;

        case "brittany":
        case "dalmatian":
        case "groenendael":
        case "malinois":
        case "maltese":
        case "samoyed":
        case "papillon":
        case "newfoundland":
        case "havanese":
          url += `https://en.wikipedia.org/w/api.php?format=json&action=query&prop=extracts|pageimages&piprop=original&titles=${breed.replace(' ', '_').concat('_dog')}`
        break;

        case "pointer":
          url += `https://en.wikipedia.org/w/api.php?format=json&action=query&prop=extracts|pageimages&piprop=original&titles=${breed.replace(' ', '_').concat('_(dog_breed)')}`;
        break;

        case "curly-coated retriever":
        case "flat-coated retriever":

        for(let i=0; i < breed.split('-').length; i++) {
          breeds.push(breed.split('-')[i][0].toUpperCase().concat(breed.split('-')[i].substr(1, 5)));
        }

          url += `https://en.wikipedia.org/w/api.php?format=json&action=query&prop=extracts|pageimages&piprop=original&titles=${breeds.toString().replace(/,/g,'-').concat(' Retriever').replace(/ /g,'_')}`;
        break;

        case "st bernard":
          url += "https://en.wikipedia.org/w/api.php?format=json&action=query&prop=extracts|pageimages&piprop=original&titles=St._Bernard_(dog)";
        break;

        case "airedale":
          url += "https://en.wikipedia.org/w/api.php?format=json&action=query&prop=extracts|pageimages&piprop=original&titles=Airedale_Terrier";
        break;

        default:
          url += `https://en.wikipedia.org/w/api.php?format=json&action=query&prop=extracts|pageimages&piprop=original&titles=${breed.replace(' ', '_')}`;
        break;
      }
    }

    jsonp(url, null, function (err, data) {
      if (err) {
        console.error(err.message);
      } else {
        document.body.style.overflow = "hidden";

        let num = Object.keys(data.query.pages),
            modal = document.getElementsByClassName('modal')[0],
            modalBody = document.getElementsByClassName('modalBody')[0],
            modalHeader = document.getElementsByClassName('modalHeader')[0],
            modalTitle = document.getElementsByClassName('modalTitle')[0],
            modalDesc = document.getElementsByClassName('modalDesc')[0],
            modalPic = document.getElementsByClassName('modalPic')[0],
            modalThumbnail = document.getElementsByClassName('thumbnail')[0];

        modal.style.height = "100%";
        modal.style.width = "100%";
        modal.style.opacity = 1;

        modalBody.style.height = "90%";
        modalBody.style.width = "90%";

        modalHeader.style.width = "90%";

        modalBody.style.opacity = 1;

        modalHeader.style.height = "45px";
        modalHeader.style.opacity = 1;

        modalDesc.style.opacity = 1;
        modalTitle.textContent = breed.replace('_', ' ');

        modalDesc.innerHTML = data.query.pages[num].extract;

        setTimeout(() => {
          modalThumbnail.style.backgroundImage = "url('" + data.query.pages[num].original.source +"')";
        
          modalThumbnail.style.opacity = 1;
          modalThumbnail.style.transition = "opacity 1s ease";
        }, 100);

        if(breed.match("schnauzer") || breed === "leonberger" || breed === "english setter" || breed === "fox terrier"
        || breed === "irish wolfhound" || breed === "lakeland terrier" || breed === "saluki" || breed === "scottish deerhound"
        || breed === "staffordshire bull terrier" || breed === "welsh springer spaniel" || breed === "whippet") {
          modalPic.style.backgroundPosition = "center";
        } else if (breed === "scottish terrier") {
          modalPic.style.backgroundPosition = "bottom";
        } else {
          modalPic.style.backgroundPosition = "top";
        }

        if($window.innerWidth <= 480) {

          if(breed === "alaskan malamute" || breed === "beagle") {
            modalThumbnail.style.backgroundPosition = "left";
          } else if(breed.match("australian") || breed === "airedale" || breed === "cairn terrier" || breed === "clumber spaniel"
          || breed === "dobermann" || breed  === "english setter" || breed === "scottish terrier" || breed === "curly-coated retriever"
          || breed === "flat-coated retriever" || breed === "harrier" || breed === "basenji" || breed === "norwich terrier"
          || breed === "irish wolfhound" || breed === "jack russell terrier" || breed === "american eskimo dog" || breed === "fox terrier" 
          || breed === "kerry blue terrier" || breed === "leonberger" || breed === "maltese" || breed === "miniature schnauzer"
          || breed === "papillon" || breed === "pekingese" || breed === "pointer" || breed === "pomeranian" || breed === "pug" 
          || breed === "rhodesian ridgeback" || breed === "shiba inu" || breed === "tibetan mastiff" || breed === "welsh springer spaniel"
          || breed === "yorkshire terrier" || breed === "lhasa apso") {
            modalThumbnail.style.backgroundPosition = "center";
          } else {
            modalThumbnail.style.backgroundPosition = "top center";          
          }
        } else {
          if(breed === "affenpinscher" || breed === "airedale" || breed === "basset hound" || breed === "giant schnauzer"
          || breed === "alaskan malamute" || breed === "australian cattle dog" || breed === "beagle" || breed === "bloodhound"
          || breed === "bluetick coonhound" || breed === "border terrier" || breed === "curly-coated retriever" || breed === "dachshund"
          || breed === "dobermann" || breed === "english setter" || breed === "english springer spaniel" || breed === "flat-coated retriever"
          || breed === "fox terrier" || breed === "mexican hairless dog" || breed === "otterhound" || breed === "rottweiler"
          || breed === "siberian husky" || breed === "staffordshire bull terrier" || breed === "whippet" || breed === "lhasa apso") {
            modalThumbnail.style.backgroundPosition = "left";
          } else if(breed === "cardigan welsh corgi" || breed === "dandie dinmont terrier" || breed === "miniature schnauzer"
          || breed === "shih tzu" || breed === "sussex spaniel" || breed === "tibetan mastiff" || breed === "weimaraner" || breed === "st bernard") {  
            modalThumbnail.style.backgroundPosition = "right";
          } else if(breed === "great dane" || breed === "king charles spaniel" || breed === "labrador retriever") {  
            modalThumbnail.style.backgroundPosition = "top center";
          } else {
            modalThumbnail.style.backgroundPosition = "center";          
          }
        }

        $window.addEventListener('resize', () => {
          if($window.innerWidth <= 480) {
            if(breed === "alaskan malamute" || breed === "beagle") {
              modalThumbnail.style.backgroundPosition = "left";
            } else if(breed.match("australian") || breed === "airedale" || breed === "cairn terrier" || breed === "clumber spaniel"
            || breed === "dobermann" || breed  === "english setter" || breed === "scottish terrier" || breed === "curly-coated retriever"
            || breed === "flat-coated retriever" || breed === "harrier" || breed === "basenji" || breed === "norwich terrier"
            || breed === "irish wolfhound" || breed === "jack russell terrier" || breed === "american eskimo dog" || breed === "fox terrier" 
            || breed === "kerry blue terrier" || breed === "leonberger" || breed === "maltese" || breed === "miniature schnauzer"
            || breed === "papillon" || breed === "pekingese" || breed === "pointer" || breed === "pomeranian" || breed === "pug"
            || breed === "rhodesian ridgeback" || breed === "shiba inu" || breed === "tibetan mastiff" || breed === "welsh springer spaniel"
            || breed === "yorkshire terrier" || breed === "lhasa apso") {
              modalThumbnail.style.backgroundPosition = "center";
            } else {
              modalThumbnail.style.backgroundPosition = "top center";          
            }
          } else {
            if(breed === "affenpinscher" || breed === "airedale" || breed === "basset hound" || breed === "giant schnauzer"
            || breed === "alaskan malamute" || breed === "australian cattle dog" || breed === "beagle" || breed === "bloodhound"
            || breed === "bluetick coonhound" || breed === "border terrier" || breed === "curly-coated retriever" || breed === "dachshund"
            || breed === "dobermann" || breed === "english setter" || breed === "english springer spaniel" || breed === "flat-coated retriever"
            || breed === "fox terrier" || breed === "mexican hairless dog" || breed === "otterhound" || breed === "rottweiler" 
            || breed === "siberian husky" || breed === "staffordshire bull terrier" || breed === "whippet" || breed === "lhasa apso") {
              modalThumbnail.style.backgroundPosition = "left";
            } else if(breed === "cardigan welsh corgi" || breed === "dandie dinmont terrier" || breed === "miniature schnauzer"
            || breed === "shih tzu" || breed === "sussex spaniel" || breed === "tibetan mastiff" || breed === "weimaraner" || breed === "st bernard") {  
              modalThumbnail.style.backgroundPosition = "right";
            } else if(breed === "great dane" || breed === "king charles spaniel" || breed === "labrador retriever") {  
              modalThumbnail.style.backgroundPosition = "top center";
            } else {
              modalThumbnail.style.backgroundPosition = "center";          
            }
          }
        }); 
    
        document.body.style.overflow = "hidden";
        document.getElementsByClassName('modalLoading')[0].style.visibility = "hidden";
        modalPic.style.backgroundImage = document.getElementsByClassName(breed.replace(/ /g, "").replace(/_/g, "") + '_pic')[0].getAttribute('data-src');
      }
    });
  }

  showModal(e) {
    
    let breed = e.target.name || e.target.textContent;
    this.loadModal(breed);
  }

  closeModal() {
    document.body.style.overflow = "auto";
    document.getElementsByClassName('modalLoading')[0].style.visibility = "visible";
    let modal = document.getElementsByClassName('modal')[0];
    let modalBody = document.getElementsByClassName('modalBody')[0];
    let modalHeader = document.getElementsByClassName('modalHeader')[0];
    let modalDesc = document.getElementsByClassName('modalDesc')[0];

    modal.style.height = 0;
    modal.style.width = 0;
    modal.style.opacity = 0;

    modal.style.transition = "height 1s ease, width 1s ease, opacity 1s ease";

    modalBody.style.height = 0;
    modalBody.style.width = 0;
    modalBody.style.opacity = 0;

    modalHeader.style.height = 0;
    modalHeader.style.width = 0;
    modalHeader.style.opacity = 0;

    modalDesc.style.opacity = 0;
    
    $window.history.replaceState('', 'Puppedia', 'https://campetty2016.github.io/Puppedia/dogs');
  }

  showSearch() {

    let mobileSearch = document.getElementsByClassName('mobileSearch')[0];

    mobileSearch.style.width = "100%";
    mobileSearch.style.opacity = 1;

    mobileSearch.style.display = "flex";
    mobileSearch.style.transition = "all 1s ease";
    document.getElementsByClassName('fa-search')[1].style.display = "none";
    document.getElementsByClassName('searchFilters')[0].style.display = "block";

    if($window.innerWidth < 480) {
      document.getElementsByClassName('filters')[0].style.display = "none";
      document.getElementsByClassName('filters')[1].style.display = "none";
    } else {
      document.getElementsByClassName('filters')[0].style.display = "block";
      document.getElementsByClassName('filters')[1].style.display = "block";
    }
  }

  filterDogs(e) {
        
    let type = !e.target.name ? 'letter' : e.target.name,
        letter = e.target.id,
        search = document.getElementsByClassName('search')[0].value.toLowerCase(),
        mobileSearch = document.getElementsByClassName('mobileSearch')[0].value.toLowerCase().replace(/<[^>]+>/g, ''),
        breedGroup = document.getElementsByClassName('filters')[0].value.toLowerCase().replace(/<[^>]+>/g, ''),
        size = document.getElementsByClassName('filters')[1].value.toLowerCase(),
        clearBtn = document.getElementsByClassName('clearBtn')[0],
        errorMessage = document.getElementsByClassName('errorMessage')[0];

    if(this.state.filters.indexOf(type) === -1) {
      this.state.filters.push(type);
    }

    if($window.innerWidth <= 568) {
      clearBtn.style.opacity = 1;
      clearBtn.style.display = "flex";
    } 

    if($window.innerWidth <= 480) {
      document.getElementsByClassName('fa-search')[0].style.display = "none";
    }

    if(!search.length && !mobileSearch.length) {
      clearBtn.style.visibility = "hidden";
      clearBtn.style.opacity = 0;
    } else {
      clearBtn.style.visibility = "visible";
      clearBtn.style.opacity = 1;
    }

    this.setState({search: search || mobileSearch});

    errorMessage.style.display = "flex";

    for(let i = 0; i < this.state.filters.length; i++) {
      // console.log(`${i} ${this.state.filters[i]}`);

      switch(this.state.filters[i]) {
        case "search":
        
          if(this.state.filters.length === 1 && this.state.filters.includes('search')){
            this.setState({breeds: this.dogBreeds.filter(breed => breed.name.match(search || mobileSearch))});
          
          } else if(document.getElementsByClassName('activeLetter')[0]) {
            this.setState({breeds: this.dogBreeds.filter(breed => breed.name.match(search || mobileSearch) && breed.name[0].toUpperCase() === document.getElementsByClassName('activeLetter')[0].textContent)});

          } else if(this.state.filters.length === 2 && this.state.filters.includes('group')) {
            // console.log('search and group')
            this.setState({breeds: this.dogBreeds.filter(breed => breed.name.match(search || mobileSearch) && breed.name.match(breedGroup))}); 
          
          } else if(this.state.filters.length === 2 && this.state.filters.includes('size')) {
            // console.log('search and size');
            this.setState({breeds: this.dogBreeds.filter(breed => breed.name.match(search || mobileSearch) && (breed.size === size || breed.size === "any"))});
          } 

          document.getElementsByClassName('fa-search')[1].style.display = "none";


        break;

        case "letter":

          clearBtn.style.display = "flex";
          clearBtn.style.visibility = "visible";
          clearBtn.style.opacity = 1;

          if(document.getElementById(letter)) {

            for(let i=0; i < letters.length; i++) {
              letters[i].classList.remove('activeLetter');
              letters[i].style.fontWeight = "normal";
            }
          }

          if(document.getElementById(letter)) {

            for(let i=0; i < letters.length; i++) {
              letters[i].classList.remove('activeLetter');
              letters[i].style.fontWeight = "normal";
            }

            document.getElementById(letter).style.fontWeight = "bold";
            document.getElementById(letter).classList.add('activeLetter');
          }

          if(this.state.filters.length === 1) {
            this.setState({breeds: this.dogBreeds.filter(breed => breed.name[0].toUpperCase() === letter)});
          } else if(this.state.filters.length === 2 && this.state.filters.includes('size')) {
            // console.log('letter and size');
            this.setState({breeds: this.dogBreeds.filter(breed => breed.name[0].toUpperCase() === letter && (breed.size === size || breed.size === "any"))});
          
          } else if(this.state.filters.length === 2 && this.state.filters.includes('search')) {
            this.setState({breeds: this.dogBreeds.filter(breed => breed.name[0].toUpperCase() === document.getElementsByClassName('activeLetter')[0].textContent && breed.name.match(search || mobileSearch))});
            // console.log('letter and search');
         
          } else if(this.state.filters.length === 2 && this.state.filters.includes('group')) {
            this.setState({breeds: this.dogBreeds.filter(breed => breed.name[0].toUpperCase() === letter && breed.name.match(breedGroup))});
          }

        break;

        case "group":

          clearBtn.style.display = "flex";
          clearBtn.style.visibility = "visible";
          clearBtn.style.opacity = 1;

          if(this.state.filters.length === 1) {
            // console.log('group');

            this.setState({breeds: this.dogBreeds.filter(breed => breed.name.match(breedGroup))});
       
          } else if(document.getElementsByClassName('activeLetter')[0]) {
            // console.log('group and letter');
    
            this.setState({breeds: this.dogBreeds.filter(breed => breed.name.match(breedGroup) && breed.name[0].toUpperCase() === document.getElementsByClassName('activeLetter')[0].textContent)});
         
          } else if(this.state.filters.length === 2 && this.state.filters.includes('size')) {
            // console.log('group and size');
    
            this.setState({breeds: this.dogBreeds.filter(breed => breed.name.match(breedGroup) && (breed.size === size || breed.size === "any"))});
         
          } else if(this.state.filters.length === 2 && this.state.filters.includes('search')) {
            // console.log('group and search');
            this.setState({breeds: this.dogBreeds.filter(breed => breed.name.match(breedGroup) && breed.name.match(search || mobileSearch))});
          }

        break;

        case "size":

          clearBtn.style.display = "flex";          
          clearBtn.style.visibility = "visible";
          clearBtn.style.opacity = 1;

          if(this.state.filters.length === 1) {
            // console.log('size');
            this.setState({breeds: this.dogBreeds.filter(breed => (breed.size === size || breed.size === "any"))});

          } else if(document.getElementsByClassName('activeLetter')[0]) {
            this.setState({breeds: this.dogBreeds.filter(breed => (breed.size === size || breed.size === "any") && breed.name[0].toUpperCase() === document.getElementsByClassName('activeLetter')[0].textContent)});

          } else if(this.state.filters.length === 2 && this.state.filters.includes('search')) {
            // console.log('size and search');
            this.setState({breeds: this.dogBreeds.filter(breed => (breed.size === size || breed.size === "any") && breed.name.match(search || mobileSearch))});

          } else if(this.state.filters.length === 2 && this.state.filters.includes('group')) {
            this.setState({breeds: this.dogBreeds.filter(breed => breed.name.match(breedGroup) && (breed.size === size || breed.size === "any"))});
            // console.log('size and group')
          } 

        break;

        default:
        break;  
      }
    }
    
    if(this.state.filters.length === 3 && this.state.filters.includes('search') && this.state.filters.includes('size') && this.state.filters.includes('group')) {  
      // console.log('search && group && size');    
      this.setState({breeds: this.dogBreeds.filter(breed => breed.name.match(search || mobileSearch) && breed.name.match(breedGroup) && (breed.size === size || breed.size === "any"))});            
    
    } else if(this.state.filters.length === 3 && this.state.filters.includes('search') && this.state.filters.includes('letter') && this.state.filters.includes('size')) {  
      this.setState({breeds: this.dogBreeds.filter(breed => breed.name.match(search || mobileSearch) && breed.name[0].toUpperCase() === document.getElementsByClassName('activeLetter')[0].textContent && (breed.size === size || breed.size === "any"))});            
      // console.log('search && letter && size');

    } else if(this.state.filters.length === 3 && this.state.filters.includes('search') && this.state.filters.includes('letter') && this.state.filters.includes('group')) {  
      this.setState({breeds: this.dogBreeds.filter(breed => breed.name.match(search || mobileSearch) && breed.name[0].toUpperCase() === document.getElementsByClassName('activeLetter')[0].textContent && breed.name.match(breedGroup))});            
      // console.log('search && letter && group');

    } else if(this.state.filters.length === 3 && this.state.filters.includes('size') && this.state.filters.includes('letter') && this.state.filters.includes('group')) {  
      this.setState({breeds: this.dogBreeds.filter(breed => (breed.size === size || breed.size === "any") && breed.name[0].toUpperCase() === document.getElementsByClassName('activeLetter')[0].textContent && breed.name.match(breedGroup))});            
      // console.log('size && letter && group');
    }

    if(this.state.filters.length === 4) {
      // console.log('all Filters');
      this.setState({breeds: this.dogBreeds.filter(breed => breed.name.match(search || mobileSearch) && breed.name.match(breedGroup) && (breed.size === size || breed.size === "any") && breed.name[0].toUpperCase() === document.getElementsByClassName('activeLetter')[0].textContent)});
    }

    // console.log(this.state.filters);
    // console.log(this.state.breeds.length);

    setTimeout(() => this.showImg(), 500);
  }

  openFilters() {
   
    document.getElementsByClassName('searchFilters')[0].style.display = "none";
    document.getElementsByClassName('filters')[0].style.display = "block";
    document.getElementsByClassName('filters')[1].style.display = "block";
    document.getElementsByClassName('fa-search')[1].style.display = "block";

    document.getElementsByClassName('mobileSearch')[0].style.display = "none";
  }


  preventSubmit(e) {
    e.preventDefault();
  }

  fixBreedImageURL(breed) {
    let breedName = breed.replace(/ /g, "").replace("alaskan", "").replace("australiancattledog","cattledog-australian").replace("bernesemountaindog","mountain-bernese")
                    .replace("bloodhound", "hound-blood").replace("brittany", "spaniel-brittany").replace("bullmastiff","mastiff-bull").replace("cairnterrier", "cairn")
                    .replace("cardiganwelshcorgi", "corgi-cardigan").replace("clumberspaniel", "clumber").replace("curly-coatedretriever","retriever-curly")
                    .replace("flat-coatedretriever", "retriever-flatcoated").replace("dobermann", "doberman").replace("greatpyrenees","pyrenees").replace("apso", "")
                    .replace("kerryblueterrier", "terrier-kerryblue").replace("irishwaterspaniel", "spaniel-irish").replace("inu","").replace("poodle", "poodle-toy")
                    .replace("pekingese", "pekinese").replace("miniaturepinscher", "pinscher-miniature").replace("leonberger", "leonberg").replace("labradorretriever", "labrador")
                    .replace("staffordshirebullterrier", "bullterrier-staffordshire").replace("westhighlandwhiteterrier", "terrier-westhighland").replace("welshspringerspaniel", "spaniel-welsh")
                    .replace("oldenglishsheepdog", "sheepdog-english").replace("chowchow", "chow");

    if((breedName.match("hound") && breed.split(" ").length === 2) || breedName.match("basset") || (breedName.match("terrier") && breed.split(" ").length === 2) || breedName.match("spaniel") && !breedName.match("brittany") && !breedName.match("irish") && !breedName.match("clumberspaniel")
    || breedName.match("collie") || breedName.match("setter") || breedName.match("bulldog") || breedName.match("dane") || breedName.match("elkhound") || breedName.match("deerhound") || (breedName.match("retriever") && !breedName.match("-") && !breedName.match("labrador") && breed.split(" ").length === 2)
    || breedName.match("schnauzer") || breedName.match("ridgeback") || (breedName.match("mastiff") && !breedName.match("bull")) || (breedName.match("sheepdog")  && breed.split(" ").length === 2)) {
      breedName = `${breed.split(" ")[1]}-${breed.split(" ")[0]}`;
    } else if((breedName.match("terrier") && !breedName.match("kerry") && !breedName.match("staffordshire") && !breedName.match("springer") && breed.split(" ").length === 3) || (breedName.match("retriever") && breed.split(" ").length === 3)) {
      breedName = `${breed.split(" ")[2]}-${breed.split(" ")[0]}`;
    } else if(breedName.match("hairless")) {
      breedName = breedName.replace("dog", "");
    }
   
    return breedName;
  }

  showClear() {
    let clearBtn = document.getElementsByClassName('clearBtn')[0];

    clearBtn.style.display = "flex";
    clearBtn.style.opacity = 1;
    clearBtn.style.visibility = "visible";
  }

  render() {

    if(this.state.filters.length) {
      document.getElementsByClassName('clearBtn')[0].style.opacity = 1;
      document.getElementsByClassName('clearBtn')[0].style.visibility = "visible";
    }

    return (
      <div className="content">
        <h2>Dogs</h2>
        <form className="form-inline my-2 my-lg-0 searchForm" onSubmit={this.preventSubmit}>
          <input className="form-control mr-sm-2 search" type="text" name="search" placeholder="Search" onChange={this.filterDogs} aria-label="Search"/> <i className="fa fa-2x fa-search"></i> 
        </form>
        <div className="wrapper">
          <div className="filterContainer">
            <div className="letterContainer">
              {this.letters.map((letter, index) =>
                <div id={letter} className="letter" key={index} onClick={this.filterDogs}>{letter}</div>
              )}
            </div>
            <div className="breedOptions">
              <div className="mobileFilters">
                <i className="fa fa-search hideSearch" onClick={this.showSearch}></i> 
                <input className="mobileSearch search" type="text" name="search" placeholder="Search" onClick={this.showClear} onChange={this.filterDogs} aria-label="Search"/> 
              </div>
              <span className="searchFilters" onClick={this.openFilters}><i className="fas fa-plus"></i> Filters</span>    

              <select className="filters" onChange={this.filterDogs} name="group">
                <option defaultValue="" disabled={!this.state.showText ? true : false}>Group</option>
                {this.breedGroups.map((breed, index) =>
                  <option key={index} value={breed}>{breed}</option>
                )}
              </select>
              <select className="filters" onChange={this.filterDogs} name="size">
                <option defaultValue="" disabled={!this.state.showText ? true : false}>Size</option>
                {this.sizes.map((size, index) =>
                  <option key={index} value={size}>{size}</option>
                )}
              </select>  
              <button  style={{opacity: this.state.breeds.length === 0 || this.state.breeds.length < 101 ? 1 : 0 || this.state.filters.length}} className="clearBtn" onClick={this.resetDogs}>All</button>  
            </div>        
          </div>
          <div className="container">
            {this.state.breeds.map((breed, index) =>
              <div key={index} className="dog" onClick={this.showModal}>
                <Link to={`/Puppedia/dogs/${breed.name.replace(/ /g, '_')}`}>
                  <div className="loading">
                    <i className={`fa fa-spinner spinner_${breed.name.replace(/ /g, '')} fa-2x fa-spin`}></i>    
                      <img data-src={breed.img ? `url('https://images.dog.ceo/breeds/${this.fixBreedImageURL(breed.name)}/${breed.img}')` : `url('${breed.image}')`}
                      data-bg={breed.bgPosition} aria-label={breed.name} name={breed.name} className={`${breed.name.replace(/ /g, "")}_pic dogPic`} onClick={this.showModal}/>
                      <noscript>
                        <img data-src={breed.img ? `url('https://images.dog.ceo/breeds/${this.fixBreedImageURL(breed.name)}/${breed.img}')` : `url('${breed.image}')`}
                        data-bg={breed.bgPosition} aria-label={breed.name} name={breed.name} className={`${breed.name.replace(/ /g, "")}_pic dogPic`} onClick={this.showModal}/>
                      </noscript>  
                  </div>
                  <div className="dogBreed">
                    {breed.name}
                  </div>
                </Link>
              </div>
            )}
            <span className="errorMessage" style={{opacity: this.state.breeds.length === 0 ? 1 : 0}}>No dogs found</span>    
          </div>
        </div>
        <div className="modal" onClick={this.closeModal}>  
          <div className="modalBody"> 
            <div className="modalHeader">
              <img className="modalPic"/>                        
              <h5 className="modalTitle"></h5>
              <span className="exit">x</span>
            </div>

            <div className="modalContent">
              <div className="modalLoading">  
                <i className="fa fa-spinner fa-2x fa-spin"></i> 
              </div>
              <img className="thumbnail"/>                        
              <p className="modalDesc"></p>
            </div>
          </div>
        </div>
        <div className="modal">

        </div>
        
      </div>
    );
  }
}

export default Dogs;



// WEBPACK FOOTER //
// ./src/Dogs.js